var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:_vm.$style.container},[_c('div',{class:_vm.$style.content},[_c('app-header-logo',{class:_vm.$style.logo}),_vm._v(" "),_c('app-header-menu',{attrs:{"just-reg":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }